import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsPublishedDateService } from '../../../core/cms';

@Component({
  selector: 'py-published-date',
  templateUrl: './published-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PublishedDateComponent implements OnInit {
  private readonly PROTOCOL_REGEX: RegExp = /^https?:\/\/|\/medias\//i;

  @Input() label: string;

  publishedDate$: Observable<string>;

  constructor(private service: CmsPublishedDateService) {}

  ngOnInit(): void {
    if (this.label && !this.PROTOCOL_REGEX.test(this.label)) {
      this.publishedDate$ = this.service.get(this.label);
    }
  }
}
